/* eslint-disable no-undef */
$(function () {
  $('.main-navigation li.menu-item-has-children').on('touchend', touchEndAction)
})

// better working main menu when using with touch screen
function touchEndAction (e) {
  e.stopPropagation() // prevents multiple touchend actions from firing
  const liElement = jQuery(this)

  if (!liElement.hasClass('touched')) {
    // first time touching link, prevent page change
    e.preventDefault()
    const touchedParent = liElement.parents('.touched')
    // hide other touched menus except current parent
    jQuery('.main-navigation li.touched').not(touchedParent).removeClass('touched')
    liElement.addClass('touched') // "touched" class is then used in css to show submenu
  }
}
